// @flow

import * as React from 'react';
import { ThemeContext, Box } from 'grommet';
import { isObject } from 'lodash';
import DownloadComponent from './DownloadComponent';
import S3DownloadComponent from './S3DownloadComponent';
import LinkComponent from './LinkComponent';
import DeleteComponent from './DeleteComponent';
import WSViewerComponent from './viewer/WSTableViewerComponent';

let TYPES = {
    link: LinkComponent,
    delete: DeleteComponent,
    download: DownloadComponent,
    s3Download: S3DownloadComponent,
    viewer: WSViewerComponent,
};

const registerActionTypes = (actions: {[string]: React.ComponentType<>}) => {
    TYPES = {
        ...TYPES,
        ...actions,
    };
};

const ActionsColumn = (rowProps: Object) => {
    const { actions, styles } = rowProps.column;
    const renderActions = [];

    actions.forEach((act, i) => {
        const Component = TYPES[act.type];

        let { label } = act;
        if (isObject(label)) {
            label = label.props.id;
        }

        const { showCondition } = act;
        if (!showCondition || showCondition(rowProps)) {
            renderActions.push(
                // eslint-disable-next-line react/no-array-index-key
                <Component row={rowProps.row} {...act} key={i} />,
            );
        }
    });

    return (
        <ThemeContext.Consumer>
            {(theme: Object) => (
                <ThemeContext.Extend value={theme?.table?.actions}>
                    <Box
                        direction="row"
                        justify="center"
                        gap="small"
                        {...styles}
                    >
                        {renderActions}
                    </Box>
                </ThemeContext.Extend>
            )}
        </ThemeContext.Consumer>
    );
};

export { registerActionTypes };

export default ActionsColumn;
